import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'
import { LogoProps } from '@components/Footer/types'
import Blink from '@components/Blink'
import logoRingier from '@assets/images/logo-ringier.svg'
import logoBlick from '@assets/images/logo-blick.svg'

type StyledLogoProps = Pick<LogoProps, 'logoType'>

const StyledLogo = styled(Blink)<StyledLogoProps>`
  ${({ logoType }) => css`
    && {
      display: inline-block;
      ${logoType === 'blick' &&
      css`
        width: 120px;
        height: 53px;
      `}
      ${logoType === 'ringier' &&
      css`
        width: 120px;
        height: 23px;
      `}
      img {
        width: 100%;
        height: auto;
      }
    }
  `}
`

const Logo: FunctionComponent<LogoProps> = ({ logoType, blinkProps }) => {
  return (
    <StyledLogo
      {...blinkProps}
      logoType={logoType}
      ariaLabel={`${logoType === 'blick' ? 'Blick' : 'Ringier'} logo`}>
      {/* eslint-disable-next-line @next/next/no-img-element  */}
      <img
        width={logoType === 'blick' ? '300' : '638'}
        height={logoType === 'blick' ? '132' : '130'}
        src={logoType === 'blick' ? logoBlick : logoRingier}
        alt={`${logoType === 'blick' ? 'Blick' : 'Ringier'} logo`}
        loading="lazy"
      />
    </StyledLogo>
  )
}

export default Logo
